





















































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import AdminBrandId from "@/mixins/adminBrandId";

// Enums/Data
import { ActionTypes, ModalTypes } from "@/data/enums";
import { ISegmentTypes } from "@/data/enums/segments";
import { ContractProductsTypes } from "@/data/enums/contractProducts";

// Types
import { IMenuRoute } from "@/models/routes";

@Component({
  components: {
    "segments-provider": () =>
      import("@/components/app/admin/segments/segmentsProvider.vue"),
    "segments-list-view": () =>
      import("@/components/app/admin/segments/segmentsListView.vue"),
    "used-contract-categories": () =>
      import(
        "@/components/app/global/contractCategories/usedContractCategories.vue"
      )
  }
})
export default class AdminSubscriptionsView extends Mixins(AdminBrandId) {
  // Data
  public segmentType = ISegmentTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION;
  public cpType = ContractProductsTypes.SUBSCRIPTIONS;

  public get canCreateSegment() {
    return this.$userCan("create_segment");
  }

  public createSubscriptionSegment(): void {
    if (!this.canCreateSegment) return;

    this.$store.dispatch("ui/openModal", {
      type: ModalTypes.SLIDE,
      config: {
        component: () =>
          import("@/components/app/admin/segments/addEditSegmentModal.vue"),
        props: {
          newSegmentRedirectRoute: "adminSubscriptionSegmentList",
          segmentType: this.segmentType,
          actionType: ActionTypes.CREATE
        }
      }
    });
  }

  public get defaultRoutes(): IMenuRoute[] {
    return [
      {
        label: this.$t("_.all"),
        to: {
          name: "admin__allSubscriptions"
        }
      },
      {
        label: this.$t("_.active"),
        to: {
          name: "admin__activeSubscriptions"
        }
      },
      {
        label: this.$t("_.awaiting_activation"),
        to: {
          name: "admin__awaitingActivationSubscriptions"
        }
      },
      {
        label: this.$t("_.subscription_pending_summary"),
        to: {
          name: "admin__pendingSummarySubscriptions"
        }
      },
      {
        label: this.$t("_.suspended"),
        to: {
          name: "admin__suspendedSubscriptions"
        }
      },
      {
        label: this.$t("_.cancelled"),
        to: {
          name: "admin__cancelledSubscriptions"
        }
      },
      {
        label: this.$t("_.lapsed"),
        to: {
          name: "admin__lapsedSubscriptions"
        }
      },
      {
        label: this.$t("_.from_last_30_days"),
        to: {
          name: "admin__fromLast30DaysSubscriptions"
        }
      },
      {
        label: this.$t("_.has_provision_issues"),
        to: {
          name: "admin__hasProvisionIssuesSubscriptions"
        }
      }
    ];
  }
}
